module.exports = __webpack_public_path__ + "img/logo_WechatWork.aadb9b20.svg";